import styled from "styled-components";

import Screens from "screens";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .box {
    width: 45%;
    margin-left: auto;
    margin-right: auto;
    padding: 30px;
    @media ${Screens.mobile}, ${Screens.tablet} {
      width: 100%;
      margin-top: 20px;
    }
    .panel {
      .error {
        color: red;
        margin-bottom: 15px;
      }
      .submit {
        margin-top: 30px;
      }
      .bottomSection {
        display: flex;
        flex-direction: row;
        margin-top: 15px;
        justify-content: space-between;
      }
    }
  }
`;
